import "./index.css";

function LandingSection() {
  return (
    <div className="section section--brief" id="home">
      <div className="brief">
        <h1>
          <b>Let&apos;s</b> Build <b>Something</b> Great <b>Together</b>!
        </h1>
        <h3>
          <label>Hi</label>, I&apos;m a <b>&quot;Javascript Developer&quot;</b> from <strong>INDIA🇮🇳</strong>. <br/>I help people build web and mobile applications to handle complex operations and promote
          their sales.
        </h3>
      </div>
    </div>
  );
}

export default LandingSection;
